<app-subscriptions-accordion [pagedResult]="pagedResult$ | async" [currentLang]="currentLang"
    (pageChangeEvent)="pageChanged($event)" (editEvent)="edit($event)" (deleteEvent)="delete($event)">
</app-subscriptions-accordion>